import { post } from '@/app/core/request';
import { BookingRoutes } from '@/app/api-routes';
import Booking from '@/types/taxcard/Booking';
import BookingPriceProjection from '@/types/projections/BookingPriceProjection';
import BookingResponse from '@/types/taxcard/BookingResponse';
import BookingDonationResponse from '@/types/taxcard/BookingDonationResponse';
import APIBooking from '@/types/taxcard/APIBooking';

class BookingApi {
  async getBookingPrice(booking: APIBooking): Promise<BookingPriceProjection> {
    return post<BookingPriceProjection>(BookingRoutes.bookingPrice, booking as any);
  }
  async bookTaxcards(booking: APIBooking): Promise<BookingResponse> {
    return post<BookingResponse>(BookingRoutes.booking, booking as any);
  }
  async donate(booking: APIBooking): Promise<BookingDonationResponse> {
    return post<BookingDonationResponse>(BookingRoutes.donate, booking as any);
  }  
  async sendHousingRegistrationForm(orderId: number, signature: string, passportNumber: string) {
    return post<void>(BookingRoutes.housingRegistrationForm(String(orderId)), { signature, passportNumber });
  }
}

export default new BookingApi();
